/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryPackageItems = sqliteTable('inventory_package_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  package_inventory_item_id: text('package_inventory_item_id'),
  child_type: text('child_type'),
  child_inventory_item_id: text('child_inventory_item_id'),
  child_appointment_service_id: text('child_appointment_service_id'),
  quantity: real('quantity'),
  included_unit_price: real('included_unit_price'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
